import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ConfirmModalComponent } from '@app/shared/dialogs/confirm-dialog/confirm-modal.component';
import { CaseDialogData } from '@app/shared/models/case';
import { Office } from '@app/shared/models/office';
import { BaseComponent } from '@app/shared/components/base/base.component';
import { Workflow } from '@app/shared/models/workflow';

@Component({
    templateUrl: './case-creation-dialog.component.html',
    styleUrls: ['./case-creation-dialog.component.scss']
})
export class CaseCreationDialogComponent extends BaseComponent implements OnInit {

    get offices(): Office[] {
        return (this.data.offices && this.data.offices.items) || [];
    }

    get workflows(): Workflow[] {
        return (this.data.workflows && this.data.workflows.items) || [];
    }

    public selectedOffice: Office;
    public selectedWorkflow: Workflow;

    constructor(public dialogRef: MatDialogRef<ConfirmModalComponent>,
                @Inject(MAT_DIALOG_DATA) public data: CaseDialogData) {
        super();
    }

    public ngOnInit() {
        super.ngOnInit();

       if (this.data.case.office_id) {
           this.selectedOffice = this.data.offices.getItem(this.data.case.office_id);
       } else if (this.data.offices.items.length === 1) {
           this.selectedOffice = this.data.offices.items[0];
       }

       this.data.workflows.items.sort(workflow => workflow.sort_order);
    }

    public accept(): void {
        this.dialogRef.close({
            office: this.selectedOffice,
            workflow: this.selectedWorkflow
        });
    }

    public close(): void {
        this.dialogRef.close(false);
    }

}
